var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNewCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.095 1.40234H3.905C2.085 1.40234 1 2.48734 1 4.30734V8.49234C1 10.3173 2.085 11.4023 3.905 11.4023H8.09C9.91 11.4023 10.995 10.3173 10.995 8.49734V4.30734C11 2.48734 9.915 1.40234 8.095 1.40234ZM8 6.77734H6.375V8.40234C6.375 8.60734 6.205 8.77734 6 8.77734C5.795 8.77734 5.625 8.60734 5.625 8.40234V6.77734H4C3.795 6.77734 3.625 6.60734 3.625 6.40234C3.625 6.19734 3.795 6.02734 4 6.02734H5.625V4.40234C5.625 4.19734 5.795 4.02734 6 4.02734C6.205 4.02734 6.375 4.19734 6.375 4.40234V6.02734H8C8.205 6.02734 8.375 6.19734 8.375 6.40234C8.375 6.60734 8.205 6.77734 8 6.77734Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewCard);
export default __webpack_public_path__ + "static/media/AddNewCard.57426bc950c6c3053e4825dc7dbb2a2d.svg";
export { ForwardRef as ReactComponent };